export default {
  selectAllLabel: 'Seleccionar Todos',
};
